import { FC } from 'react';
import { Box, Typography, Paper, Alert } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

interface TabDescriptionProps {
  title: string;
  description: string;
  details?: string[];
}

export const TabDescription: FC<TabDescriptionProps> = ({ title, description, details }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Alert severity="info" icon={<InfoIcon />} sx={{ mb: 2 }}>
        <Box>
          <Typography variant="h6" sx={{ mt: 0, mb: 1 }}>
            {title}
          </Typography>
          <Typography variant="body2" sx={{ mb: details ? 1 : 0 }}>
            {description}
          </Typography>
          {details && (
            <Box component="ul" sx={{ mt: 1, mb: 0, pl: 2 }}>
              {details.map((detail, idx) => (
                <li key={idx}>
                  <Typography variant="body2">{detail}</Typography>
                </li>
              ))}
            </Box>
          )}
        </Box>
      </Alert>
    </Box>
  );
};
